import { render, staticRenderFns } from "./TextView.vue?vue&type=template&id=51a72954&scoped=true&"
import script from "./TextView.vue?vue&type=script&lang=js&"
export * from "./TextView.vue?vue&type=script&lang=js&"
import style0 from "./TextView.vue?vue&type=style&index=0&id=51a72954&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a72954",
  null
  
)

export default component.exports